'use client';

import { graphql } from 'src/gql';

export const TaxEnrollmentFormFragment = graphql(/* GraphQL */ `
  fragment TaxEnrollmentForm on Household {
    id
    name
    primaryClient {
      id
      user {
        id
        fullName
      }
    }
    coClient {
      id
      user {
        id
        fullName
      }
    }
    taxEnrollments {
      id
      billableClient {
        id
      }
      enrollmentType
      price
    }
  }
`);
